import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=393b0370&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=393b0370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b0370",
  null
  
)

export default component.exports